<template>
  <div>
    <div class="container">
      <div class="d-flex justify-content-start align-items-center py-4 px-3">
      <label for="dataTable" class="iot-station me-5">Sensor Details</label>

      <!-- <label for="time-range-select" class="custom-label me-1">Hub:</label>
      <div class="form-group me-3">
        <select class="form-select form-select-sm form-control shadow-none custom-input custom-dropdown"
          v-model="selectedSensorHub">
          <option v-for="hub in sensorhubOptions" :key="hub.uuid" :value="hub.uuid">
            {{ hub.name }}
          </option>
        </select>
      </div>

      <label for="time-range-select" class="custom-label me-1">Controller:</label>
      <div class="form-group">
        <select class="form-select form-select-sm form-control shadow-none custom-input custom-dropdown"
          v-model="selectedSensorController">
          <option v-for="controller in sensorcontrollerOptions" :key="controller.uuid" :value="controller.uuid">
            {{ controller.name }}
          </option>
        </select>
      </div> -->
    </div>
      <div class="row px-4 position-relative">
        <div v-if="loading" class="spinner-overlay d-flex justify-content-center align-items-center">
  <div class="spinner-border text-primary" >
  </div>
</div>
<div v-else-if="!loading && noRecordFound" class="spinner-overlay d-flex justify-content-center align-items-center  text-muted">
        No Record Found
      </div>
        <div v-else v-for="(chunk, index) in chunks" :key="index" class="col-md-6 px-1 mt-2">
          <table class="table table-bordered table-hover table-responsive">
            <thead>
              <tr class="text-center">
                <th scope="col" width="60" class="align-middle header-row">Sr No.</th>
                <th scope="col" class="align-middle header-row">Tag Number</th>
                <th scope="col" class="align-middle header-row">Unit</th>
                <th scope="col" class="align-middle header-row">Current Value</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, rowIndex) in chunk" :key="rowIndex" class="text-center">
                <td :class="[getRowClass(row.controller)]">{{ index * 7 + rowIndex + 1 }}</td>
                <td :class="[getRowClass(row.controller)]">{{ row.physicalid }}</td>
                <td :class="[getRowClass(row.controller)]">{{ row.unit }}</td>
                <td :class="[getRowClass(row.controller)]">{{ row.value }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { ddReportComponent, ddReportHub } from '@/http/dashboard/report.http';
import { getSensorDetailData } from '@/http/dashboard/iot-insight.http';
export default {
  name: 'graph1',
  data() {
    return {
      suppressControllerWatcher: false,
      isSensorDetailTimer: 0,
      loading: false,
      noRecordFound: false,
      // sensorhubOptions: [],
    // sensorcontrollerOptions: [],
    // selectedSensorHub: '',
    // selectedSensorController: '',
      sensorData: [],
    };
  },
  computed: {
    chunks() {
      // Split the data into chunks of 8 rows each
      const chunkSize = 7;
      let result = [];
      for (let i = 0; i < this.sensorData.length; i += chunkSize) {
        result.push(this.sensorData.slice(i, i + chunkSize));
      }
      return result;
    },
  },
async mounted() {
  this.fetchSensorDetailData()
  // await this.fetchSensorHubOptions();
  // await this.fetchSensorControllerOptions();
  this.sensorDetailTimer = setInterval(() => {
  this.isSensorDetailTimer = 1
    this.fetchSensorDetailData()
  }, 5000);
},
beforeUnmount() {
  clearInterval(this.sensorDetailTimer);
},
// watch: {
//   async selectedSensorHub(newHubId) {
//     this.suppressControllerWatcher = true;
//     await this.fetchSensorControllerOptions(newHubId);
//     this.fetchSensorDetailData(); // call from hub change
//     this.suppressControllerWatcher = false;
//   },
//   selectedSensorController() {
//     if (this.suppressControllerWatcher) return;
//     this.fetchSensorDetailData(); // only call when not triggered by hub change
//   }
// },
methods: {
//   async fetchSensorHubOptions() {
// try {
//   const response = await ddReportHub();
//   this.sensorhubOptions = response || [];

//   if (this.sensorhubOptions.length > 0) {
//     this.selectedSensorHub = this.sensorhubOptions[0].uuid;
//   } else {
//     this.selectedSensorHub = '';
//   }

//   // Always fetch controllers, even if hub is empty
//   // await this.fetchSensorControllerOptions(this.selectedSensorHub);
//   // this.fetchSensorDetailData(); // safe call based on both selections
// } catch (error) {
//   console.error('Error fetching hub options:', error);
//   this.sensorhubOptions = [];
//   this.selectedSensorHub = '';
//   // await this.fetchSensorControllerOptions('');
//   // this.fetchSensorDetailData();
// }
// },

// async fetchSensorControllerOptions(hubId) {
// try {
//   const response = await ddReportComponent({ id: hubId || "" });
//   this.sensorcontrollerOptions = response || [];

//   if (this.sensorcontrollerOptions.length > 0) {
//     this.selectedSensorController = this.sensorcontrollerOptions[0].uuid;
//   } else {
//     this.selectedSensorController = '';
//   }
// } catch (error) {
//   console.error('Error fetching controller options:', error);
//   this.sensorcontrollerOptions = [];
//   this.selectedSensorController = '';
// }
// },
async fetchSensorDetailData() {
if (this.isSensorDetailTimer === 0) {
  this.loading = true;
  this.sensorData = [];
}

// if (!this.selectedSensorHub || !this.selectedSensorController) {
//   this.loading = false;
//   this.noRecordFound = true;
//   this.sensorData = [];
//   return;
// }
// const payload = {
//   hubid: this.selectedSensorHub || "",
//   controllerid: this.selectedSensorController || "",
// };

try {
  const response = await getSensorDetailData();

  if (!response || response.length === 0 || !Array.isArray(response)) {
    this.noRecordFound = true;
    this.sensorData = [];
  } else {
     response.sort((a, b) => {
        if (a.tagnumber < b.tagnumber) return -1;
        if (a.tagnumber > b.tagnumber) return 1;
        return 0;
      });
    this.noRecordFound = false;
    this.sensorData = response;
  }
} catch (error) {
  console.error('Error fetching Sensor Details data:', error);
  this.sensorData = [];
  this.noRecordFound = false;
} finally {
  this.loading = false;
  this.isSensorDetailTimer = 0;
}
},
getRowClass(controller) {
  switch (controller) {
    case 'GMBS Controller':
      return 'gmbs-row';
    case 'TPP Controller 11x11':
      return 'tpp-row';
    case 'CPP controller (GCP-5)':
      return 'cpp-row';
    case 'RMP Controller':
      return 'rmp-row';
    default:
      return '';
  }
}


}


};
</script>

<style scoped>
 .gmbs-row {
background-color: #fff0f6; 
color: #7b0132;
}
.header-row {
background-color: #e6f1fb; 
color: #003e75;
}
.tpp-row {
background-color: #fbf7ee; 
color: #5a3f01;
}

.cpp-row {
background-color: #f1e6fc; 
color: #6b3c98;
}

.rmp-row {
background-color: #edfff9; 
color: #016040;
}


.spinner-overlay {
position: absolute;
top: 160px;
left: 0;
width: 100%;
height: 100%;
background-color: rgba(255, 255, 255, 0.7);
z-index: 10;
}

</style>
